<template>
  <BasePageContainer class="search">
    <div class="form-group">
      <span class="material-icons search__icon">
        search
      </span>
      <input
        v-model="searchKeyword"
        type="search"
        class="form-control form-control--search"
        placeholder="検索キーワード">
    </div>
    <div>
      <div
        v-if="!searchKeyword">
        ここに検索結果が表示されます
      </div>
      <ul
        v-else-if="goals.length > 0"
        class="list-unstyled">
        <search-card
          v-for="goal in goals"
          :key="goal.id"
          :goal="goal"
          :lock-goal-option="lockGoalOption"
          :search-keyword="searchKeyword" />
      </ul>
      <div v-else>
        検索キーワードに該当する目標や活動はありませんでした
      </div>
    </div>
  </BasePageContainer>
</template>

<script>
import SearchCard from '@/components/view/SearchCard' 
export default {
  components: {
    SearchCard
  },
  data() {
    return {
      searchKeyword: '',
      goals: [],
      lockGoalOption: false
    }
  },
  watch: {
    searchKeyword() {
      this.fetchGoals()
    }
  },
  async created() {
    this.$store.commit('startLoading')
    this.lockGoalOption = await this.$axios.get('/tenants/')
      .then((res) => res.data.lockGoalOption)
      .catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })
    this.$store.commit('finishLoading')
  },
  methods: {
    fetchGoals() {
      if (!this.searchKeyword) return
      this.$store.commit('startLoading')
      const encoded = encodeURIComponent(this.searchKeyword)
      this.$axios.get(`/goals/txt_search/?search=${encoded}&ordering=-common_updated_at`).then((res) => {
        this.goals = res.data.results
      }).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(()=> {
        this.$store.commit('finishLoading')
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.form-group{
  position: relative;
}
.search{  
  &__icon{
    position: absolute;
    left: 4px;
    top: 12px;
  }
  
}
</style>